export default {
  CUSTOMER_DOCUMENT_WEALTH_REPOSITORY: Symbol.for('CUSTOMER_DOCUMENT_WEALTH_REPOSITORY'),
  UPDATE_CUSTOMER_DOCUMENT_WEALTH_BANK_STATEMENT_COMMAND: Symbol.for('UPDATE_CUSTOMER_DOCUMENT_WEALTH_BANK_STATEMENT_COMMAND'),
  UPDATE_CUSTOMER_DOCUMENT_WEALTH_PROOF_ADDRESS_COMMAND: Symbol.for('UPDATE_CUSTOMER_DOCUMENT_WEALTH_PROOF_ADDRESS_COMMAND'),
};
